import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { lectureRoute } from '../lectures/lectures-routing.module';
import { CourseDetailComponent } from './course-detail/course-detail.component';
import { CoursesComponent } from './courses/courses.component';
import { CourseResolver } from './shared/course-resolver.service';
import { SyllabusDetailComponent } from "../syllabuses/syllabus-detail/syllabus-detail.component";
import { SyllabusEditComponent } from "../syllabuses/syllabus-edit/syllabus-edit.component";
const routes: Routes = [
  {
    path: 'courses',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: CoursesComponent
      },
      {
        path: ':id',
        resolve: {
          course: CourseResolver
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: CourseDetailComponent
          },
          {
            path: 'syllabus',
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: SyllabusDetailComponent
              },
              {
                path: 'edit',
                pathMatch: 'full',
                component: SyllabusEditComponent
              }]
          },
          lectureRoute
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class CoursesRoutingModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/courses-routing.module.ts